import { render, staticRenderFns } from "./VerifyEmailModal.vue?vue&type=template&id=fb73e08a&"
import script from "./VerifyEmailModal.vue?vue&type=script&lang=ts&"
export * from "./VerifyEmailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports